import React from 'react'
import { withStyles } from '@material-ui/core/styles'

import { Typography, Box, Alert } from '@material-ui/core'
import styles from './styles'
import SelectLanguage from './select-language'
import { CoreButton, CoreTextField, CoreFormLayout } from 'src/components/core'
import { Icon } from '@iconify/react'
const StepDescription = props => {
  const {
    profession,
    setProfession,
    audience,
    setAudience,
    description,
    setDescription,
    sendTitleRequest,
    errorMessage,
    language,
    setLanguage,
    classes,
  } = props

  return (
    <>
      <Box m={2}></Box>
      <SelectLanguage language={language} setLanguage={setLanguage} />
      <CoreFormLayout
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
        width="100%"
        itemGap="16px"
        itemsPerRow={1}
      >
        <CoreTextField
          value={profession}
          label={
            language != 'English'
              ? 'Tell us your profession ' + '(in ' + language + ')'
              : 'Tell us your profession'
          }
          placeholder="Business Coach, Personal Trainer..."
          onChange={event => setProfession(event.currentTarget.value)}
          fullWidth
        />
        <CoreTextField
          value={audience}
          variant="outlined"
          multiline
          label={
            language != 'English'
              ? 'What is your target audience? ' + '(in ' + language + ')'
              : 'What is your target audience?'
          }
          placeholder="Entrepreneurs, Beginner-Level Yoga learners..."
          onChange={event => setAudience(event.currentTarget.value)}
          fullWidth
        />
      </CoreFormLayout>
      <Typography className={classes.descriptionText}>
        The key to successful AI guidance is a precise description. Your
        description should be at least 5 words.
      </Typography>
      <Box m={2}></Box>

      <CoreTextField
        value={description}
        multiline
        rows={2}
        placeholder="A course about how to create ..."
        fullWidth
        label={
          language != 'English'
            ? 'Description ' + '(in ' + language + ')'
            : 'Description'
        }
        onChange={event => setDescription(event.currentTarget.value)}
      ></CoreTextField>
      <Box m={2}></Box>
      {errorMessage == true && (
        <>
          <Alert severity="warning">
            A problem occurred due to GPT-3. Please try again.
          </Alert>
          <Box m={2}></Box>
        </>
      )}
      {/*<PurposeSelection purpose={purpose} setPurpose={setPurpose} />*/}
      <Box m={2}></Box>
      <CoreButton
        variant="contained"
        onClick={() => sendTitleRequest()}
        disabled={
          profession == undefined ||
          audience == undefined ||
          description == undefined ||
          description?.length < 20
            ? true
            : false
        }
      >
        Generate Title <Icon icon="mage:coin-a" style={{ margin: '0 4px' }} /> 1
      </CoreButton>
      <Box m={2}></Box>
    </>
  )
}

export default withStyles(styles)(StepDescription)
